import { render, staticRenderFns } from "./TicketsStats.vue?vue&type=template&id=94a39fa8"
import script from "./TicketsStats.vue?vue&type=script&lang=js"
export * from "./TicketsStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports